export enum LoginProvider {
  Rappider = 'jwt'
}
